import styles from '../MaterialPreviewModal.module.css';
import { HoverDropdown, HoverDropdownItem } from '../../../common/HoverDropdown';
import { MaterialActionButton } from './MaterialActionButton';
import type { MaterialAction } from './useMaterialActions';

/**
 * PC 用フッター。useMaterialActions() が返した配列だけを描画する。
 * 可視条件・活性条件はここでは一切判断しない (= mobile と同じ配列を見る)。
 */
export function MaterialActionsDesktop({ actions }: { actions: MaterialAction[] }) {
  const visible = actions.filter((a) => a.visible);
  const pick = (group: MaterialAction['group']) => visible.filter((a) => a.group === group);

  const adsActions = pick('ads');
  const basicActions = pick('basic');
  const editActions = pick('edit');
  const folderActions = pick('folder');
  const selectionActions = pick('selection');
  const deleteActions = pick('delete');

  return (
    <div className={styles.footerDesktop}>
      {/* 左端: 削除ボタン */}
      <div className={styles.footerLeft}>
        {deleteActions.map((action) => (
          <MaterialActionButton key={action.key} action={action} />
        ))}
      </div>

      {/* 中央: アクションボタン */}
      <div className={styles.footerCenter}>
        {/* グループ1: 広告アップロード、ダウンロード、シェア、保護 */}
        <div className={styles.footerButtonGroup}>
          {/* 広告アップロード（ドロップダウン）
              Amazon/Google いずれも brandConfig で off の場合はボタン自体を隠す */}
          {adsActions.length > 0 && (
            <HoverDropdown
              trigger={
                <button type="button" className="btn-modal">
                  <img src="/badge_ad.svg" alt="" style={{ width: '16px', height: '16px', marginRight: '6px' }} />
                  <span className={styles.buttonText}>広告</span>
                </button>
              }
              position="top"
            >
              <div
                style={{
                  padding: '6px 12px',
                  background: '#2a2a2a',
                  borderBottom: '1px solid #333',
                  fontSize: '10px',
                  color: 'white',
                  fontWeight: 600,
                  letterSpacing: '0.02em',
                }}
              >
                広告クリエイティブ入稿
              </div>
              {adsActions.map((action) => (
                <HoverDropdownItem key={action.key} onClick={action.onClick} disabled={action.disabled}>
                  {action.label}
                </HoverDropdownItem>
              ))}
            </HoverDropdown>
          )}

          {basicActions.map((action) => (
            <MaterialActionButton key={action.key} action={action} />
          ))}
        </div>

        {/* グループ2: 編集、AIに修正依頼、Canvaで編集、動画生成 */}
        <div className={styles.footerSeparator}></div>
        <div className={styles.footerButtonGroup}>
          {editActions.map((action) => (
            <MaterialActionButton key={action.key} action={action} />
          ))}
        </div>

        {/* グループ3: フォルダ移動 */}
        {folderActions.length > 0 && (
          <div className={styles.footerShareWrapper}>
            <div className={styles.footerSeparator}></div>
            {folderActions.map((action) => (
              <MaterialActionButton key={action.key} action={action} />
            ))}
          </div>
        )}
      </div>

      {/* 右端: 選択素材に追加 */}
      <div className={styles.footerRight}>
        {selectionActions.map((action) => (
          <MaterialActionButton key={action.key} action={action} />
        ))}
      </div>
    </div>
  );
}
